import { Drawer } from '@material-ui/core';
import CustomButton from 'components/CustomInput/Button';
import TextHeader from 'components/CustomText/TextHeader';
import UploadButtons from 'components/UploadButton';
import React from 'react';
import { useDispatch } from 'react-redux';
import { setGlobal } from 'store/global/reducer';
import styled from 'styled-components/macro';

const SLayout = styled.div`
    padding: 15px;
`;

const SHeader = styled.div``;

const SContent = styled.div`
    margin-top: 30px;
`;

const SActionLayout = styled.div`
    margin-top: 30px;
    display: flex;
    justify-content: flex-end;
`;

const CTADrawer = ({ isShow, onClose = () => null }) => {
    const dispatch = useDispatch();

    const closeDrawer = () => {
        dispatch(
            setGlobal({
                showCTAUploadDrawer: false,
            }),
        );
    };

    return (
        <Drawer open={isShow} anchor={'right'} onClose={closeDrawer}>
            <SLayout>
                <SHeader>
                    <TextHeader>CTA/CTA Amendment</TextHeader>
                </SHeader>
                <SContent>
                    <div>Please Upload your file before submitting</div>
                    <div style={{ marginTop: 15 }}>
                        <UploadButtons />
                    </div>
                </SContent>

                <SActionLayout>
                    <CustomButton onClick={closeDrawer} type={'cancel'}>
                        Cancel
                    </CustomButton>
                    <CustomButton disabled style={{ marginLeft: 10 }}>
                        Submit
                    </CustomButton>
                </SActionLayout>
            </SLayout>
        </Drawer>
    );
};

export default CTADrawer;
